<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новое сообщение</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading || msg.username.length > 0" @click="sendForm(false)">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="msg_name"
                        v-model="msg.name"
                        v-validate="'required|max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        single-line
                        solo
                        text
                        required/>
                </v-flex>

                <v-layout>
                    <v-flex xs6 mb-6>
                        <v-layout mb-4>
                            <v-flex xs12>
                                <v-subheader class="pa-0">Укажите тип</v-subheader>

                                <div class="mb-1">
                                    <v-select solo v-model="select" :items="items"/>
                                </div>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs8>
                                <template v-if="select === 'img'">
                                    <upload-img :image-width="1024" :image-height="1024" v-model="msg.image">
                                        <template slot="activator">
                                            <v-avatar size="200px" v-ripple class="grey lighten-3" tile
                                                      v-if="!msg.image">
                                                <img src="/static/img/media/image_blank.svg"
                                                     alt="Нажмите чтобы добавить картинку для сообщения"/>
                                            </v-avatar>

                                            <v-avatar size="200px" v-ripple tile v-else>
                                                <img :src="msg.image.imageURL" alt="Изображение для сообщения"/>
                                            </v-avatar>
                                        </template>
                                    </upload-img>
                                </template>

                                <template v-else-if="select === 'video'">
                                    <v-subheader class="pa-0">Видео (до 2мб)
                                    </v-subheader>

                                    <div class="mb-4">
                                        <v-avatar @click="clickInputVideo" v-if="!msg.video.url" size="200px" v-ripple
                                                  class="grey lighten-3" tile>
                                            <img src="/static/img/media/image_blank.svg"
                                                 alt="Нажмите чтобы добавить картинку для сообщения"/>
                                        </v-avatar>

                                        <video height="200" width="200" ref="video" v-show="msg.video.url" controls
                                               :src="msg.video.url"></video>
                                    </div>

                                    <v-file-input ref="input" class="file-input-video" style="max-width: 200px"
                                                  v-model="video" prepend-icon="mdi-camera" accept=".mp4"
                                                  @change="changeVideo"
                                                  @click:clear="clearVideo"
                                                  label="Выберите видео" outlined dense/>
                                </template>
                            </v-flex>

                            <v-flex xs4>
                                <v-subheader class="pa-0">Отправить сразу</v-subheader>
                                <v-checkbox :label="msg.send ? 'Да' : 'Нет'" v-model="msg.send" class="mt-0"/>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex offset-1 xs6>
                        <v-subheader class="pa-0">Описание</v-subheader>
                        <v-textarea
                            ref="msg_text"
                            v-model="msg.text"
                            v-validate="'required|max:255'"
                            :error-messages="errors.collect('text')"
                            data-vv-name="text"
                            single-line
                            solo
                            text
                            required
                            counter="255"/>
                    </v-flex>
                </v-layout>

                <v-layout row class="mb-4">
                    <v-toolbar text>
                        <v-toolbar-title>Отправить тестовое сообщение</v-toolbar-title>
                    </v-toolbar>
                </v-layout>

                <v-flex xs6>
                    <v-subheader class="pa-0">Username телеграм пользователя</v-subheader>
                    <v-text-field
                        ref="msg_username"
                        v-model="msg.username"
                        v-validate="'max:50'"
                        data-vv-name="name"
                        :error-messages="errors.collect('username')"
                        single-line
                        solo
                        text/>
                </v-flex>

                <v-flex xs12>
                    <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading"
                           @click="sendForm(true)">
                        Отправить
                        <span slot="loader" class="custom-loader">
                                <v-icon light>cached</v-icon>
                            </span>
                    </v-btn>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
import UploadImg from '../../../components/Media/Upload'
import Telegram from '../../../api/telegram'

export default {
    components: { UploadImg },
    $_veeValidate: {
        validator: 'new'
    },
    name: 'addTgMessage',
    data: () => ({
        loading: false,
        msg: {
            name: '',
            image: '',
            username: '',
            video: {
                url: '',
                base64: '',
            },
            text: '',
            send: true,
            testSend: false,
        },

        select: 'img',

        video: null,

        items: [
            {
                text: 'Изображение',
                value: 'img',
            },

            {
                text: 'Видео',
                value: 'video',
            },
        ],

        dictionary: {
            custom: {
                name: {
                    required: 'Введите тайтл',
                    max: 'Превышено максимальное количество символов в названии'
                },

                text: {
                    required: 'Описание не заполнено',
                    max: 'Превышено максимальное количество символов в описании'
                }
            }
        }
    }),

    // watch: {
    //     select (value) {
    //         this.clearVideo()
    //         this.msg.image = ''
    //     },
    // },

    mounted () {
        this.$validator.localize('ru', this.dictionary)
    },

    methods: {
        sendForm (isTest = false) {
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (!isValid) return

                    this.loading = true

                    if (this.select === 'img') {
                        this.msg.video = ''
                    } else {
                        this.msg.image = ''
                    }

                    this.msg.testSend = isTest

                    Telegram
                        .create(this.msg)
                        .then(response => {
                            let msg = response.data.data
                            let text = isTest ? 'Успех! Сообщение добавлено' : 'Успех! Тестовое сообщение добавлено'
                            this.$store.commit('storeTgMessage', msg)
                            this.$store.commit('showSnackbar', {
                                text: text,
                                color: 'success'
                            })

                            if (!isTest) {
                                this.$router.push({ name: 'tgMessageRoot' })
                            } else {
                                this.$router.push({ name: 'editTgMessage', params: { tgMessageId: msg.id } })
                            }
                        })
                        .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error }))
                        .finally(() => this.loading = false)
                })
        },

        toBase64 (file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },

        async changeVideo (file) {
            if (!file) return

            if (file.size > 2097152) {
                this.$store.commit('showSnackbar', { text: 'Размер файла превышает 2 мб.' })
                this.clearVideo()

                return
            }

            this.msg.video = {
                base64: await this.toBase64(file),
                url: URL.createObjectURL(file),
            }
        },

        clearVideo () {
            this.msg.video = ''
            this.video = ''
        },

        clickInputVideo () {
            let input = this.$refs.input
            if (input) {
                input.$refs.input.click()
            }
        }
    }
}
</script>

<style lang="scss">
.file-input-video {
    .v-input__prepend-outer {
        display: none;
    }
}
</style>
